module.exports = __webpack_public_path__ + "img/coin.a908738a.svg";